export function formatWeight(grams: number): string {
    if (grams < 1000) {
        return `${grams} g`;
    }
    const kg = grams / 1000;
    if (kg < 1000) {
        return `${parseFloat(kg.toFixed(2))} kg`;
    }
    const t = kg / 1000;
    return `${parseFloat(t.toFixed(2))} t`;
}

export function formatVolume(cm3: number): string {
    if (cm3 < 1000000) {
        return `${cm3} cm³`;
    }
    const m3 = cm3 / 1000000;
    return `${parseFloat(m3.toFixed(2))} m³`;
}

// Volumes are stored in cm³ (1 L = 1000 cm³). Liters read better than raw cm³ for
// delivery-sized volumes, which rarely reach the 1 m³ threshold of formatVolume.
export function formatVolumeInLiters(cm3: number): string {
    const liters = cm3 / 1000;
    return `${parseFloat(liters.toFixed(1))} L`;
}
